export default __webpack_public_path__ + "static/media/regular-ribbon.0cb8ad03.svg";